import { serverGet, serverPost, serverDelete, serverPut } from "utils/serverFetch";
import {serverUrl} from "app/constants";
import Cookies from "js-cookie";


async function fetchAcapellas(voice_model_uuid) {
    // TEMP cuz we couldnt figre out optional uuid in endpoint
    if(!voice_model_uuid || voice_model_uuid == null) {
        return await serverGet("/acapella_stack/list", {
            voice_model_uuid: "00000000-00000000-00000000-00000000",
        });
    } else {
        return await serverGet("/acapella_stack/list", {
            voice_model_uuid: voice_model_uuid, //rohan voice
        });
    }

}

async function searchCatalog(query, voice_model_uuid) {
    // TODO dont hard code voice model
    return await serverGet(`/catalog/search`, { query: query, voice_model_uuid: voice_model_uuid });
}
async function connectSpotify(code) {
    // TODO dont hard code voice model
    return await serverPost(`/integration/connect_spotify`, { code });
}
async function presaveSong(catalog_uuid, voice_model_uuid) {
    // TODO dont hard code voice model
    return await serverPost(`/catalog/presave`, { catalog_uuid: catalog_uuid, voice_model_uuid: voice_model_uuid  });
}
async function generateAcapellaStackPreview(voice_model_uuid, acapella_stack_uuid) {
    return await serverPost("/acapella_stack/generate_preview", {
        voice_model_uuid: voice_model_uuid,
        acapella_stack_uuid: acapella_stack_uuid,
    });
}

async function fetchAcapellaStackDetails(voice_model_uuid, acapella_stack_uuid) {
    return await serverGet("/acapella_stack/detail", {
        voice_model_uuid: voice_model_uuid, //rohan voice
        acapella_stack_uuid: acapella_stack_uuid,
    });
}
async function fetchUserAcapellas() {
    return await serverGet("/user_acapella_stack/list", {});
}

async function fetchVoices() {
    return await serverGet("/voice_model/list", {});
}

async function fetchPublicVoices() {
    return await serverGet("/voice_model/list_public", {});
}

async function createUserAcapellaStack(acapella_stack_price_slug, layers) {
    return await serverPost("/user_acapella_stack/create", {
        acapella_stack_purchase: {
            slug: acapella_stack_price_slug,
        },
        layers
    });
}

async function purchaseUserAcapellaStack(user_acapella_stack_uuid) {
    return await serverPost(`/user_acapella_stack/purchase/${user_acapella_stack_uuid}`, {});
}

async function blendVoices(blendVoiceParts) {
    console.log("fetchVoiceApi");
    return await serverPost(`/voice_model/blend`, {
        blendParts: blendVoiceParts,
    });
}

async function getCustomerSubscriptions() {
    console.log("getCustomerSubscriptions");
    return await serverGet(`/account/list-subscriptions`, {});
}

async function getSubscriptionChoices() {
    console.log("getSubscriptionChoices");
    return await serverGet(`/account/subscription-choices`, {})
}

// Deprecated?
// async function createSubscription(priceId) {
//     console.log("fetchVoiceApi");
//     return await serverPost(`/account/create-subscription/${priceId}`, {})
// }

async function grantAccess(voice_model_id, email) {
    console.log("fetchVoiceApi");
    return await serverPost(`/voice-models/${voice_model_id}/add-accessor`, email)
}

async function listAccessEmails(voice_model_id) {
    return await serverGet(`/voice-models/${voice_model_id}/list-accessors`, {})
}

async function removeAccessor(voice_model_id, email) {
    return await serverPost("/voice_model/remove_accessor", {
        voice_model_id,
        email
    });
}

async function getUserProfile() {
    return await serverGet(`/user_profile/`, {})
}

async function updateUsername(username) {
    return await serverPost('/user_profile/update_username', { username: username })
}


async function getCheckoutSessionMetadata(optionalMetadata={}) {
    let gtag_client_id
    try {
        gtag_client_id = await Cookies.get("_ga")
    } catch (e) {
        console.error(e)
    }
    return {
        metadata: JSON.stringify({
            tolt_referral: (window as any).tolt_referral,
            gtag_client_id: gtag_client_id,
            ...optionalMetadata
        })
    }
}

async function redirectToTrialCheckout() {
    const metadata = await getCheckoutSessionMetadata()
    const responseBody = await serverGet(
        '/stripe/checkout/trial',
        metadata,
    );
    window.location.href = responseBody.url;
}

async function redirectToCreatorCheckout(isYearly = false) {
    const metadata = await getCheckoutSessionMetadata()
    const slug = isYearly ? 'creator-yearly' : 'creator-monthly'
    const responseBody = await serverGet(
        `/stripe/checkout/${slug}`,
        metadata,
    );
    window.location.href = responseBody.url;
}
async function redirectToStarterCheckout(isYearly = false) {
    const metadata = await getCheckoutSessionMetadata()
    const slug = isYearly ? 'starter-yearly' : 'starter-monthly'
    const responseBody = await serverGet(
        `/stripe/checkout/${slug}`,
        metadata,
    );
    window.location.href = responseBody.url;
}

async function redirectToAddOn(slug) {
    const metadata = await getCheckoutSessionMetadata()
    const responseBody = await serverGet(
        `/stripe/checkout/${slug}`,
        metadata,
    );
    window.location.href = responseBody.url;
}

async function redirectToStripeConnect() {
    const responseBody = await serverGet(
        `/stripe/connected_account`,
        {metadata: JSON.stringify({tolt_referral: (window as any).tolt_referral})},
    );
    console.log(responseBody);
    window.location.href = responseBody.data.url;
}

async function redirectToCheckoutSlugWithMetadata(slug, metadata) {
    const requestMetadata = await getCheckoutSessionMetadata(metadata)
    const responseBody = await serverGet(
        `/stripe/checkout/${slug}`,
        requestMetadata,
    );
    window.location.href = responseBody.url;
}

async function createTrainingJob(formData) {
    return await serverPost(`/create-training-job`, formData)
}

async function getUploadUrl(jobType, filenames) {
    return await serverPost(`/get-upload-url`, {
        filenames: filenames,
        jobType: jobType,
    })
}

async function incrementAudioFileDownloadCount(audioFileId) {
    return await serverPost(`/audio-file/${audioFileId}/increment_download_count`, {})
}

async function createInferenceJob(formData) {
    return await serverPost(`/inference/create`, formData)
}

async function createStemSplitJob(formData) {
    return await serverPost(`/inference/create/stem-split`, formData)
}

async function createLyricsToMusicJob(formData) {
    return await serverPost(`/inference/create/lyrics-to-music`, formData)
}

async function createSamplerStyleRefPreset(formData) {
    return await serverPost(`/sampler_style_ref_presets/create`, formData)
}

async function getInferenceJob(jobUuid) {
    return await serverGet(`/inference/get_by_job_uuid/${jobUuid}`, {})
}

async function rateJob(jobUuid, rating) {
    return await serverPost(`/inference/rate/${jobUuid}`, { rating })
}

async function fetchJobs() {
    return await serverGet('/inference/history', {})
}

async function fetchStemSplitJobs() {
    return await serverGet('/inference/history/stem-split', {})
}

async function fetchLyricsToMusicJobs() {
    return await serverGet('/inference/history/lyrics-to-music', {})
}

async function fetchPublicSamplerStyleRefPresets(frontendTab) {
    return await serverGet(`/sampler_style_ref_presets/list_public`, { frontend_tab: frontendTab })
}

async function fetchSamplerStyleRefPresets(frontendTab) {
    return await serverGet(`/sampler_style_ref_presets/list`, { frontend_tab: frontendTab })
}

async function makeSamplerStyleRefPresetPublic(preset_id) {
    return await serverPost(`/sampler_style_ref_presets/${preset_id}/make_public`, {})
}

async function makeSamplerStyleRefPresetPrivate(preset_id) {
    return await serverPost(`/sampler_style_ref_presets/${preset_id}/make_private`, {})
}

async function deleteSamplerStyleRefPreset(preset_id) {
    return await serverPost(`/sampler_style_ref_presets/${preset_id}/delete`, {})
}

async function updateSamplerStyleRefPreset(preset_id, newData) {
    return await serverPut(`/sampler_style_ref_presets/${preset_id}`, newData)
}

async function deleteJob(job_uuid) {
    return await serverPost(`/worker/delete_job`, { job_uuid });
}

async function fetchRecentInferenceJobs() {
    return await serverGet('/inference/recent', {})
}

async function fetchRecentStemSplitJobs() {
    return await serverGet('/inference/recent/stem-split', {})
}

async function fetchRecentLyricsToMusicJobs() {
    return await serverGet('/inference/recent/lyrics-to-music', {})
}

async function deleteVoice(voiceModelId) {
    return await serverDelete(`/voice_model/${voiceModelId}`, {})
}

async function updateVoice(voiceModelId, newVoiceData) {
    return await serverPut(`/voice-models/${voiceModelId}`, newVoiceData)
}

async function createTTSVoiceModel(formData) {
    return await serverPost(`/tts_voice_models/create`, formData)
}

async function fetchTtsVoices() {
    return await serverGet(`/tts_voice_models/list`, {})
}

async function fetchTtsPublicVoices() {
    return await serverGet(`/tts_voice_models/list_public`, {})
}

// Singer Only Methods
async function createAcapellaStack(formData) {
    return await serverPost(`/acapella_stack/create`, formData)
}

export const Api = {
    searchCatalog,
    presaveSong,
    generateAcapellaStackPreview,
    fetchAcapellas,
    fetchAcapellaStackDetails,
    fetchUserAcapellas,
    fetchVoices,
    fetchPublicVoices,
    blendVoices,
    getCustomerSubscriptions,
    getSubscriptionChoices,
    connectSpotify,
    grantAccess,
    listAccessEmails,
    removeAccessor,
    getUserProfile,
    redirectToTrialCheckout,
    redirectToCreatorCheckout,
    redirectToStarterCheckout,
    redirectToAddOn,
    createUserAcapellaStack,
    purchaseUserAcapellaStack,
    redirectToCheckoutSlugWithMetadata,
    redirectToStripeConnect,
    getUploadUrl,
    createTrainingJob,
    getInferenceJob,
    createInferenceJob,
    fetchJobs,
    deleteJob,
    fetchRecentInferenceJobs,
    deleteVoice,
    updateVoice,
    createAcapellaStack,
    fetchRecentStemSplitJobs,
    createStemSplitJob,
    createTTSVoiceModel,
    fetchTtsVoices,
    fetchTtsPublicVoices,
    rateJob,
    incrementAudioFileDownloadCount,
    fetchStemSplitJobs,
    createLyricsToMusicJob,
    fetchLyricsToMusicJobs,
    fetchRecentLyricsToMusicJobs,
    createSamplerStyleRefPreset,
    fetchSamplerStyleRefPresets,
    fetchPublicSamplerStyleRefPresets,
    makeSamplerStyleRefPresetPublic,
    makeSamplerStyleRefPresetPrivate,
    deleteSamplerStyleRefPreset,
    updateUsername,
    updateSamplerStyleRefPreset,
}
